import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@coworker/http-client";
import { Item } from "../../types/item";
import { formatProductIdWithDots } from "@coworker/reusable/formatters/product.formatter";
import {
  toHalfWidth,
  containsFullWidthCharacters,
} from "../../../tasks/helpers/toHalfWidth";
import { isValidItemNumber } from "@coworker/utils/products.helper";

async function fetchItemInfoAndPrice(itemNo: string): Promise<Item | null> {
  const halfWidthItemNo = containsFullWidthCharacters(itemNo)
    ? toHalfWidth(itemNo)
    : itemNo;

  if (!isValidItemNumber(halfWidthItemNo)) {
    return null;
  }

  const itemInfo = await httpClient.tasks.get<Item>(
    `/items/item-info-price?itemNo=${halfWidthItemNo}`
  );
  return itemInfo && itemInfo.no
    ? ({
        ...itemInfo,
        noFormatted: formatProductIdWithDots(itemInfo?.no),
      } as Item)
    : null;
}

export function useItemInfoAndPrice(itemNo: string) {
  return useQuery({
    queryKey: ["item", "sr", itemNo],
    queryFn: async () => await fetchItemInfoAndPrice(itemNo),
    enabled: !!itemNo,
    staleTime: 86400000, // Since this data does not change frequently, it can stay fresh for a long time
    refetchOnWindowFocus: false,
  });
}
